interface BaseComparator<T> {
    compare(guess: T, actual: T): Result
}

type Result = {
    state: ResultState
    direction?: CloseDirection
}

enum ResultState {
    MATCH,
    CLOSE,
    FAR,
    FAIL
}

enum CloseDirection {
    NONE,
    UP,
    DOWN
}

export type { BaseComparator, Result }

export { ResultState, CloseDirection }
